import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { ArrowFullRightIcon, ErrorIcon, TickCircleIcon } from '@motorway/mw-highway-code';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';
import { getSectionState, SECTION_STATES } from 'Utilities/sectionState';
import LocalTexts from 'Utilities/sectionState.texts.json';

import styles from './SummaryTile.scss';

const LocalT = new MDText(LocalTexts);

type SummaryTileProps = {
  isCompleted?: boolean;
  isDependencyCompleted?: boolean;
  isReactivated?: boolean;
  label: string;
  onClick?: () => void;
  path?: string;
  status?: string;
}

const SummaryTile = ({
  isCompleted = false,
  isDependencyCompleted = undefined,
  isReactivated = false,
  label,
  onClick = undefined,
  // TODO: stop casting when i18n lib changed
  path,
  status = LocalT.translate('complete') as string,
}: SummaryTileProps) => {
  const onButtonClick = () => {
    DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.DOCUMENTS_UPLOAD_SUMMARY_TILE_CLICKED(label);
    onClick?.();
  };

  const { state, tileStatus } = getSectionState({
    completed: isCompleted,
    dependencyCompleted: isDependencyCompleted,
    reactivated: isReactivated,
  });

  const completed = state === SECTION_STATES.COMPLETED;
  const reactivated = state === SECTION_STATES.REACTIVATED;
  const active = state === SECTION_STATES.ACTIVE;

  const activeTile = active || reactivated;

  let statusIcon;
  if (completed) {
    statusIcon = (<TickCircleIcon filled={false} size="xsmall" />);
  } else if (reactivated) {
    statusIcon = (<ErrorIcon filled={false} size="xsmall" />);
  }

  const statusText = completed ? status : tileStatus;

  const tile = (
    <div
      className={cx(styles.tile, styles[state])} data-cy="summaryTile"
    >
      <span className={styles.tileContent}>
        <span className={styles.tileContentText}>
          <h3>{label}</h3>
          <span className={styles.status}>
            {statusIcon}
            <p>{statusText}</p>
          </span>
        </span>
        {activeTile && <span className={styles.arrow}><ArrowFullRightIcon size="xsmall" /></span>}
      </span>
    </div>
  );

  const summaryTile = path && activeTile
    ? <Link className={styles.summaryTileLink} onClick={onButtonClick} to={path}>{tile}</Link>
    : tile;

  return summaryTile;
};

export default SummaryTile;
